import React from "react";
import { Select as SelectComponent } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { v4 as uuidv4 } from "uuid";
import FieldLabel from "../FieldLabel";
import { getSelectIcon } from "../../utils/Helpers";

type OptionType = {
  name?: string;
  optionElement?: HTMLElement;
  domainId?: number;
  icon?: string; // in the case then MenuItem has icon
  value?: string | number;
};

type PropsType = {
  value: string | number;
  onChange: (value: any) => void;
  options: OptionType[] | undefined;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
};

const Select = ({
  value,
  onChange,
  options,
  disabled,
  label = "",
}: PropsType) => {
  const theme = useTheme();

  return (
    <>
      <FieldLabel label={label} disabled={disabled} />
      <FormControl fullWidth>
        <SelectComponent
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          onChange={(value) => onChange(value)}
          value={value.toString()}
          IconComponent={(props) => getSelectIcon(props.className)}
          disabled={disabled}
          MenuProps={{
            sx: {
              "& .MuiMenuItem-root": {
                display: "flex",
                height: theme.spacing(8),
                gap: theme.spacing(2),
                "&.Mui-selected": {
                  backgroundColor: "rgba(42, 94, 123, 0.3)",
                },
              },
            },
          }}
        >
          {options &&
            options.map((option) => {
              const id = uuidv4();
              <MenuItem value="">
                <em>None</em>
              </MenuItem>;
              return (
                <MenuItem
                  key={id}
                  value={option.value}
                  sx={{
                    display: "flex",
                    height: theme.spacing(6),
                    gap: theme.spacing(2),
                    color: "#000",
                  }}
                >
                  {option.icon && <img src={option.icon} />}
                  {option.name}
                </MenuItem>
              );
            })}
        </SelectComponent>
      </FormControl>
    </>
  );
};

export default Select;
